import get from 'lodash/get';
import { State, getState } from './applicationState';
import { PlayStates, SubscriptionStatus } from './constants';
import guideIdUtils from './guideIdUtils';
function getClassificationProperty({ profileClassification, playClassification = profileClassification, }) {
    return (getPlayClassification(playClassification) ??
        getProfileClassification(profileClassification));
}
function getPlayClassification(classification) {
    return (getState(State.nowPlaying)?.classification?.[classification] ??
        adsSettings.currentProfile()?.actions?.play?.[classification] ??
        null);
}
function getProfileClassification(classification) {
    return (adsSettings.currentProfile()?.metadata?.properties?.classification?.[classification] ?? null);
}
const adsSettings = {
    currentProfile() {
        const profiles = getState(State.profiles);
        const selectedGuideId = getState(State.selectedGuideId);
        return profiles?.[selectedGuideId];
    },
    canShowAds() {
        const currentProfile = this.currentProfile();
        const adsEnabled = getState(State.adsEnabled);
        const adsEnabledOnThisPage = get(currentProfile, 'metadata.properties.ads.adEligible', true);
        const isPlaying = getState(State.playerStatus) === PlayStates.playing;
        const nowPlaying = getState(State.nowPlaying);
        const canShowAds = get(nowPlaying, 'ads.canShowAds', true);
        return (adsEnabled &&
            !this.isPremium() &&
            adsEnabledOnThisPage &&
            (canShowAds || !isPlaying));
    },
    canShowPrerollAds() {
        const currentProfile = this.currentProfile();
        const adsEnabledOnThisPage = get(currentProfile, 'metadata.properties.ads.adEligible', true);
        const nowPlaying = getState(State.nowPlaying);
        const canShowPrerollAds = get(nowPlaying, 'ads.canShowPrerollAds', true);
        const unlockDetails = getState(State.unlockDetails);
        const disablePreroll = get(unlockDetails, 'DisablePreroll', false) && this.isUnlocked();
        return (!this.isPremium() &&
            adsEnabledOnThisPage &&
            canShowPrerollAds &&
            !disablePreroll);
    },
    getGuideItemDetails() {
        const guideItemDetails = {};
        const nowPlaying = getState(State.nowPlaying);
        guideIdUtils.extractTypedGuideIds(get(nowPlaying, 'secondaryGuideId'), guideItemDetails);
        guideIdUtils.extractTypedGuideIds(get(nowPlaying, 'primaryGuideId'), guideItemDetails);
        const currentProfile = this.currentProfile();
        const guideId = get(currentProfile, 'guideId');
        guideIdUtils.extractTypedGuideIds(guideId, guideItemDetails);
        return guideItemDetails;
    },
    getGenreId() {
        return getClassificationProperty({
            profileClassification: 'primaryGenreId',
            playClassification: 'genreId',
        });
    },
    getBandId() {
        return getClassificationProperty({ profileClassification: 'bandId' });
    },
    isFamilyContent() {
        return getClassificationProperty({
            profileClassification: 'isFamilyContent',
        });
    },
    isMatureContent() {
        return getClassificationProperty({
            profileClassification: 'isMatureContent',
        });
    },
    isEvent() {
        return getClassificationProperty({ profileClassification: 'isEvent' });
    },
    isOnDemand() {
        return getClassificationProperty({ profileClassification: 'isOnDemand' });
    },
    isPremium() {
        return getState(State.subscriptionStatus) === SubscriptionStatus.active;
    },
    isUnlocked() {
        const unlockDetails = getState(State.unlockDetails);
        const unlockEndDate = get(unlockDetails, 'EndDate');
        return unlockEndDate ? new Date(unlockEndDate) > Date.now() : false;
    },
    getClass() {
        return getClassificationProperty({
            playClassification: 'contentType',
            profileClassification: 'rootGenreClassification',
        });
    },
    getNowPlayingGuideIds() {
        const ret = [];
        const nowPlaying = getState(State.nowPlaying);
        const primaryGuideId = guideIdUtils.sanitize(get(nowPlaying, 'primaryGuideId'));
        if (primaryGuideId) {
            ret.push(primaryGuideId);
        }
        const secondaryGuideId = guideIdUtils.sanitize(get(nowPlaying, 'secondaryGuideId'));
        if (secondaryGuideId) {
            ret.push(secondaryGuideId);
        }
        return ret;
    },
};
export default adsSettings;
